import { UNKNOWN } from './viewPageTransitionSourceConstants.ts';

type TransitionSource = string;

let transitionSource: TransitionSource | undefined;

export const setViewTransitionSource = (source: TransitionSource): void => {
	transitionSource = source;
};

export const getViewTransitionSource = (): string => {
	return transitionSource || UNKNOWN;
};

export const resetViewTransitionSource = (): void => {
	transitionSource = undefined;
};
